<template>
  <div v-if="loadingConfig" v-loading="loadingConfig" class="fullscreen-loading">
  </div>
  <div v-else id="app">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      config: state => state.config.data,
      loadingConfig: state => state.config.loading
    })
  },
  created () {
    this.$store.dispatch('isAuthorize')
    this.$store.dispatch('getConfig')
  }
}
</script>

<style>

@font-face {
  font-family: 'Nucleo Outline';
  src: url('./assets/fonts/nucleo-outline.eot');
  src: url('./assets/fonts/nucleo-outline.eot') format('embedded-opentype'),
  url('./assets/fonts/nucleo-outline.woff2') format('woff2'),
  url('./assets/fonts/nucleo-outline.woff') format('woff'),
  url('./assets/fonts/nucleo-outline.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Roboto';
  src: url('./assets/fonts/Roboto-Regular.ttf');
}

#app {
  font-family: 'Roboto';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #55595c;
}
body,
html,
#app {
  height: 100%;
}
.fullscreen-loading {
  height: 100%;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
